import './capacitor-init';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LNAuthProvider } from '@shared/context/LNAuthContext';
import { ThemeProvider } from './context/ThemeContext';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <LNAuthProvider>
          <App />
        </LNAuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
